(() => {
  const money = (cents, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency || 'USD' }).format((Number(cents) || 0) / 100);
  const init = () => {
    const data = document.querySelector('[data-lm-variants]');
    if (!data) return;
    const variants = JSON.parse(data.textContent || '[]');
    const currency = data.dataset.currency || 'USD';
    const controls = [...document.querySelectorAll('[data-lm-option]')];
    const selectVariant = () => {
      const choices = [];
      controls.forEach((control) => { choices[Number(control.dataset.lmOption) - 1] = control.value; });
      const variant = variants.find((item) => item.options.every((value, index) => !choices[index] || choices[index] === value)) || variants[0];
      if (!variant) return;
      document.querySelectorAll('[data-lm-variant-id]').forEach((input) => { input.value = variant.id; });
      document.querySelectorAll('[data-lm-price]').forEach((node) => {
        const quantity = Number(node.dataset.qty || 1);
        const discount = Number(node.dataset.discountCents || 0);
        node.textContent = money((variant.price * quantity) - discount, currency);
      });
      document.querySelectorAll('[data-lm-compare]').forEach((node) => {
        const compare = Number(variant.compare_at_price || 0);
        node.hidden = !(compare > variant.price);
        if (!node.hidden) node.textContent = money(compare * Number(node.dataset.qty || 1), currency);
      });
      document.querySelectorAll('[data-lm-save]').forEach((node) => {
        const quantity = Number(node.dataset.qty || 1);
        const discount = Number(node.dataset.discountCents || 0);
        const saving = (Number(variant.compare_at_price || 0) * quantity) - ((Number(variant.price || 0) * quantity) - discount);
        node.hidden = saving <= 0;
        if (!node.hidden) {
          const suffix = node.dataset.suffix ? ` ${node.dataset.suffix}` : '';
          node.textContent = `${node.dataset.prefix || 'Save'} ${money(saving, currency)}${suffix}`;
        }
      });
      document.querySelectorAll('[data-lm-button]').forEach((button) => {
        button.disabled = !variant.available;
        const label = button.querySelector('[data-lm-button-label]');
        if (label) label.textContent = variant.available ? label.dataset.available : label.dataset.sold;
      });
      document.querySelectorAll('[data-lm-availability]').forEach((node) => {
        node.dataset.soldOut = String(!variant.available);
        node.textContent = variant.available ? node.dataset.available : node.dataset.sold;
      });
    };
    controls.forEach((control) => {
      if (control.dataset.lmBound === 'true') return;
      control.dataset.lmBound = 'true';
      control.addEventListener('change', (event) => {
        [...document.querySelectorAll('[data-lm-option]')].filter((item) => item.dataset.lmOption === event.currentTarget.dataset.lmOption).forEach((item) => { item.value = event.currentTarget.value; });
        selectVariant();
      });
    });
    selectVariant();
  };
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  init();
})();
